export default __webpack_public_path__ + "static/media/review.5d6c3109.svg";